import { startGemsPinchSequence } from 'src/game/shop/Helpers';
import { trackPinchEvent } from './analytics/events';
import * as Inventory from 'src/replicant/inventory';
import { user } from 'src/StateObserver';
import { getGameScene } from 'src/game/minigame/match2-timestep/game/getGameScene';
import { PinchTrigger } from './analytics/pinch/pinch.redux';

/**
 * Check if user has enough gems to perform a pinch
 * If not, start pinch sequence on top to purchase gems.
 */
export async function movesPinchCheck(price: number, trigger: PinchTrigger) {
  let success = true;

  if (!canPurchase(price)) {
    const gemsNeeded = Math.abs(getBalanceAfterPurchase(price));

    trackPinchEvent(
      {
        resource: 'moves',
        trigger,
      },
      getGameScene()?.getPinchAnalyticsData(),
    );

    await startGemsPinchSequence({
      feature: 'match2',
      pinch: 'gems',
      gemsNeeded,
      crossplayTracking: {
        feature: 'match_continue',
        subFeature: `match_continue_gems`,
        continueCount: user().match2.continues,
      },
    });

    success = canPurchase(price);
  }

  return success;
}

function canPurchase(price: number) {
  return getBalanceAfterPurchase(price) >= 0;
}

function getBalanceAfterPurchase(price: number) {
  return Inventory.getters.getGems(user()) - price;
}
